document.addEventListener('DOMContentLoaded', ()=> {
    let deliveryTime = 0;
    let deliveryText = null;
    let deliveryCaption = null;
    let initialLocation = null;
    const variantMetafields = window.wesite.variant_metafields;
    const timeMap = {}
    let selectedId = window.wesite.product.selected_or_first_available_variant.id;

    function main(){
        initSaveProductAttachmentListener();
        initPickUpAvailabilityListener();
        initOpenPickupAvailabilityListener();
        initVariantChangeListener();
    }

    function buildTimeMap(){
        for(const variantId in variantMetafields){
            timeMap[variantId] = {}
            const currentMetafield = variantMetafields[variantId];
            let lager = currentMetafield[initialLocation];
            const secondLagerValue = initialLocation === "lagerbestand_a" ? "lagerbestand_b" : "lagerbestand_a";
            let secondLager = currentMetafield[secondLagerValue];
            lager = lager || 0;
            secondLager = secondLager || 0;
            if(lager > 0){
                timeMap[variantId][initialLocation] = "2-4";
            }
            if(secondLager > 0){
                timeMap[variantId][secondLagerValue] = "2-4";
            }
            if (lager === 0 && secondLager === 0 ){
                timeMap[variantId][initialLocation] = currentMetafield["lieferzeit"];
                timeMap[variantId][secondLagerValue] = currentMetafield["lieferzeit"];
            }

            if(lager == 0 && secondLager > 0){
                timeMap[variantId][initialLocation] = "5-7";
            } 
            if(lager > 0 && secondLager == 0){
                timeMap[variantId][secondLagerValue] = "5-7";
            }
            timeMap[variantId].attachment = null;
        }
        //console.log("timeMap",timeMap);
    }

    function setDeliveryTime(){
        const time = timeMap[selectedId]
        const attachmentTime =  time ? time.attachment : 0;
        const initialTime = time[initialLocation] || 0;
        if(attachmentTime > initialTime){
            deliveryTime = attachmentTime;
        } else{
            deliveryTime = initialTime;
        }
        updateDeliveryTime();
    }

    function initSaveProductAttachmentListener(){
        document.addEventListener("we-save-attachment", (e) => {
            let currentDeliveryTime = timeMap[selectedId][initialLocation] || 0;
            currentDeliveryTime = parseInt(String(currentDeliveryTime).split("-")[0]);
            
            const selected = e.detail.selected;
            const products = e.detail.products;
            const selectedMap = selected.reduce((acc, current) => {
                acc[current.property] = acc[current.property] || {};
                const findProduct = products.find(p => p.name === current.property);
                if(findProduct){
                    acc[current.property] = findProduct;
                }
                return acc;
            }, {});
            timeMap[selectedId].attachment = null;
            if(selected.length === 0){
                setDeliveryTime();
                return;
            }

            for(const select of selected){
                const productsObj = selectedMap[select.property];
                if(productsObj){
                    const product = productsObj.products.find(p =>{
                        const lagerA = p.lagerbestand_a ? parseInt(p.lagerbestand_a) : 0;
                        const lagerB = p.lagerbestand_b ? parseInt(p.lagerbestand_b) : 0;
                        return p.variants[0].id == select.id && lagerA === 0 && lagerB === 0;
                    });
                    if(product && product.deliveryTime > currentDeliveryTime){
                        currentDeliveryTime = product.deliveryTime;
                        timeMap[selectedId].attachment = currentDeliveryTime;
                    }
                }
            }
            setDeliveryTime();
        });
    }

    function initPickUpAvailabilityListener(){
        document.addEventListener("we-pickup-availability", ()=>{
            const pickUpText = document.querySelector(".pickup-availability-preview");
            if(pickUpText){
                deliveryText = pickUpText.querySelector(".caption").textContent;
                deliveryCaption = pickUpText.querySelector(".caption");
                const location = pickUpText.querySelector(".caption-large .color-foreground").innerHTML;
                if(location.toLocaleLowerCase().includes("hebertshausen")){
                    initialLocation = "lagerbestand_a";
                } else if(location.toLocaleLowerCase().includes("wallersdorf")){
                    initialLocation = "lagerbestand_b";
                }
            }
            buildTimeMap();
            setDeliveryTime();
        })
    }

    function updateDeliveryTime(){
        if(deliveryTime){
                deliveryCaption.textContent = `Voraussichtlich abholbereit in ${deliveryTime} Tagen`;
                deliveryCaption.classList.remove("we-warning");
        } else{
            deliveryCaption.innerHTML = "Bitte informieren Sie sich über die aktuelle Lieferzeit";
            deliveryCaption.classList.add("we-warning");
        }
    }

    function initOpenPickupAvailabilityListener(){
        document.addEventListener("we-open-pickup-availability", ()=>{
            const lists = document.querySelectorAll("pickup-availability-drawer .pickup-availability-list__item");
            if(!lists || lists.length === 0) return;
            lists.forEach(list => {
                const headLine = list.querySelector("h3.h4").innerHTML;
                if(headLine.toLocaleLowerCase().includes("hebertshausen")){
                    const attachmentTime = timeMap[selectedId].attachment || 0;
                    const time = attachmentTime > timeMap[selectedId]["lagerbestand_a"] ? attachmentTime : timeMap[selectedId]["lagerbestand_a"];
                    list.querySelector(".pickup-availability-preview.caption-large").innerHTML = showDrawerText(time);
                } else if(headLine.toLocaleLowerCase().includes("wallersdorf")){
                    const attachmentTime = timeMap[selectedId].attachment || 0;
                    const time = attachmentTime > timeMap[selectedId]["lagerbestand_b"] ? attachmentTime : timeMap[selectedId]["lagerbestand_b"];
                    list.querySelector(".pickup-availability-preview.caption-large").innerHTML = showDrawerText(time);
                }
            })

        })
    }

    function showDrawerText(time){
        return `
            <svg class="icon icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
            <path fill="#108043" stroke="#fff" d="M16.136 6.979h0l.003-.004a1.499 1.499 0 00-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 103.94 12.06l2.999 3s0 0 0 0c.289.29.675.44 1.1.439h.019a1.5 1.5 0 001.08-.522l6.998-7.998z"></path>
                </svg>${time ? 'Abholung verfügbar, voraussichtlich abholbereit in ' + time + ' tagen' : 'Abholung verfügbar - Bitte informieren Sie sich über die aktuelle Lieferzeit'}
        `
    }

    function initVariantChangeListener(){
        document.addEventListener("wesite-variant-change", (e)=>{
            const variantId = e.detail.id;
            selectedId = variantId;
            setDeliveryTime();
        })
    }


    main();
});